/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Agent } from "./Agent";
export const AgentResponse = core.serialization.object({
    data: Agent.optional(),
});
